import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { MultistepsService } from '@app/modules/builder/base/services';
import { SessionService, StepsIdEnum, RequestTypesEnum, StepsRouteEnum, CompaniesEnum,
  LookupsService, ApplicantMessageEnum, StepsCodeEnum, Attachment, ConstantsService } from '@app/base/core';
import { FormGroup } from '@angular/forms';
import { CanComponentDeactivate } from '@app/base/shared';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';
import { SocoHttpService } from '@app/base/soco';
import { Subscription } from 'rxjs';
import { AlertService } from '@app/base/alerts/alert.service';
@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css']
})
export class ReviewComponent implements OnInit, CanComponentDeactivate, OnDestroy {
  form: any;
  addressForm: any;
  informationForm: any;
  premiseForm: any;
  typeForm: FormGroup;
  alertMsg: any = [];
  fileData: Attachment;
  getFilesSubscription: Subscription;
  // BId: string;
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  stepsCodeEnum: typeof StepsCodeEnum = StepsCodeEnum;
  requestTypeEnum: typeof RequestTypesEnum = RequestTypesEnum;
  stepsRouteEnum: typeof StepsRouteEnum = StepsRouteEnum;
  companiesEnum: typeof CompaniesEnum = CompaniesEnum;
  applicantMessageEnum: typeof ApplicantMessageEnum = ApplicantMessageEnum;
  message = '';
  dontKnowText = 'Don\'t Know';
  dontKnowDefaultPressure = 'Dont\'t Know, Default Delivery Pressure is ';
  @HostListener('window:beforeunload', ['$event']) onBeforeUnload(event) {
    if (this.socoHttp.sessionActive) {
      event.preventDefault();
      // Specially for chrome...
      event.returnValue = this.constantsSvc.changes;
    }
  }
  constructor(public wizardSvc: MultistepsService, private config: SocoConfigurationService,
    public lookupSvc: LookupsService, public sessionSvc: SessionService, public socoHttp: SocoHttpService,
    public constantsSvc: ConstantsService, public alertService: AlertService) {
    this.wizardSvc.syncActiveStep(StepsIdEnum.REVIEW);
  }
   ngOnInit() {
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.REVIEW).form;
    this.typeForm = this.wizardSvc.getStepById(this.stepsIdEnum.TYPE).form;
    this.addressForm = this.wizardSvc.getStepById(this.stepsIdEnum.ADDRESSES).form;
    this.informationForm = this.wizardSvc.getStepById(this.stepsIdEnum.INFORMATION).form;
    this.premiseForm = this.wizardSvc.getStepById(this.stepsIdEnum.PREMISE).form;
    // Load common lookups
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      // Banner messages for Review page
      if (val) {
         this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Review Builder'
        ));
        this.alertService.info(this.alertMsg.message);
      }
    });
    if (this.wizardSvc.duplicatedRequest) {
      const msg = this.lookupSvc.messages.find(x =>
        x.itemName.toUpperCase() === this.wizardSvc.serviceAddress.state.short_name.toUpperCase() &&
        x.messageType.toUpperCase() === this.wizardSvc.paramApplicantMessage.toUpperCase() && x.application === 'GRE');
      this.message = msg ? msg.message : 'NA';
    }
    // If request type is subdivision get Documents
    const builderID = this.wizardSvc.steps[StepsIdEnum.INFORMATION].form.value.builderCompany.id === undefined ? this.wizardSvc.BId :
    this.wizardSvc.steps[StepsIdEnum.INFORMATION].form.value.builderCompany.id;
    this.wizardSvc.BId = builderID;
    this.getFilesSubscription = this.wizardSvc.getAllFiles(builderID).subscribe(result => {
    this.fileData = result.data;
    });
  }
  // unsubscribe the subscriptions
  ngOnDestroy() {
if (this.getFilesSubscription) {
  this.getFilesSubscription.unsubscribe();
}
  }
  next() { this.wizardSvc.nextStep(); }// Navigate to Next page
  back() { this.wizardSvc.previousStep(); } // Navigate to Previous page
  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState: RouterStateSnapshot) {
    if (this.form) {
      return this.wizardSvc.canDeactivateStep(route, state, nextState);
    } else {
      return true;
    }
  }
  // Type of residential delivery pressure required
  residentialDeliveryPressure(delValue) {
    return !delValue.controls['residentialDeliveryPressure'].value['itemName'] ? '' :
      (delValue.controls['residentialDeliveryPressure'].value['itemName']
        === this.dontKnowText ? this.dontKnowDefaultPressure +
        this.lookupSvc.defaultResidentialPressure.lookupValues[0]['itemName'] :
        delValue.controls['residentialDeliveryPressure'].value['itemName']);
  }
   // Type of subdivision delivery pressure required
  subdivisionDeliveryPressure(delValue) {
    return !delValue.controls['subdivisionDeliveryPressure'].value['itemName'] ? '' :
      (delValue.controls['subdivisionDeliveryPressure'].value['itemName']
        === this.dontKnowText ? this.dontKnowDefaultPressure +
        this.lookupSvc.defaultResidentialPressure.lookupValues[0]['itemName'] :
        delValue.controls['subdivisionDeliveryPressure'].value['itemName']);
  }
   // Type of commercial delivery pressure required
  commercialDeliveryPressure(item) {
    return !item.controls['commercialDeliveryPressure'].value['itemName'] ? '' :
      (item.controls['commercialDeliveryPressure'].value['itemName']
        === this.dontKnowText ? this.dontKnowDefaultPressure +
        this.lookupSvc.defaultCommercialPressure.lookupValues[0]['itemName'] :
        item.controls['commercialDeliveryPressure'].value['itemName']);
  }
}
